import axios from 'axios';

const instance = axios.create({
    // baseURL: process.env.NODE_ENV === 'production' ? 'https://a.ninjatrip.net/api/v3' : 'https://dev-a.ninjatrip.net/api/v3'
    baseURL: process.env.apiEndpoint+'/api/v4'
});

export default instance;
